module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-heading mb-3"
  }, [_vm._v(_vm._s(_vm.schema.label))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-112a8f47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/controls/SectionHeadingControl.vue
// module id = 2453
// module chunks = 1